

exports.__esModule = true;
var onetouch = {
    signup_onetouch_variant1_graphic: 'signUpVariantOne',
    signup_onetouch_variant2: 'signUpVariantTwo',
    signup_onetouch_control: 'control'
};

var singlepassword = {
    singlepassword_test: 'xoon_single_password_test'
};

var xoon_optional_signup_content_change = {
    xoon_optional_signup_content_change_gb_test: {
        subTitle: 'common.createPayPalPropTest1',
        yesCreateAccount: 'common.yesCreateAccountTest1'
    },
    xoon_optional_signup_content_change_test1: {
        title: 'common.getBenefitsLine1Test1',
        subTitle: 'common.createPayPalPropTest1'
    },
    xoon_optional_signup_content_change_test2: {
        title: 'common.getBenefitsLine1Test1',
        subTitle: 'common.createPayPalPropTest2'
    },
    xoon_optional_signup_content_change_test3: {
        title: 'common.getBenefitsLine1Test2',
        subTitle: 'common.createPayPalPropTest3'
    },
    xoon_optional_signup_content_change_test4: {
        title: 'common.getBenefitsLine1Test2',
        subTitle: 'common.createPayPalPropTest4'
    }
};

var xoon_wps_interstitial_optional_signup = {
    XO_XOONBOARDING_WPS_INTERSTITIAL_OPTIONAL_SIGNUP_Control: {
        mode: 'guestonly',
        interstitialEligible: true
    },
    XO_XOONBOARDING_WPS_INTERSTITIAL_OPTIONAL_SIGNUP_Treatment1: {
        mode: 'guest',
        interstitialEligible: false
    },
    XO_XOONBOARDING_WPS_INTERSTITIAL_OPTIONAL_SIGNUP_Treatment2: {
        mode: 'guest',
        buyerMode: 'guest',
        interstitialEligible: true
    }
};

exports['default'] = {
    test: {
        onetouch: onetouch,
        singlepassword: singlepassword,
        xoon_optional_signup_content_change: xoon_optional_signup_content_change,
        xoon_wps_interstitial_optional_signup: xoon_wps_interstitial_optional_signup
    }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/guest/constants/pxpExperimentConstants.js
// module id = ./components/xo-guest-components/src/guest/constants/pxpExperimentConstants.js
// module chunks = 1